export default __webpack_public_path__ + "static/media/IINVSYS.d1056a4b.svg";